export const mapStringToArray = (str, sep) => {
  console.log('arasdf', str.length)
  if (str.length > 1) {
    const arr = str.split(sep);
    return arr;
  }
  return [];
}